var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"legend-btn btn btn-sm",class:{ 'sewer-btn': _vm.isSewerCrewColor, 'legend-visible': _vm.legendVisible },on:{"click":_vm.onClick}},[_vm._v("Legend")])}
var staticRenderFns = []

export { render, staticRenderFns }